import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Renderer2 } from '@angular/core';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-intercom-messenger-bot',
  imports: [RmaIconComponent, TranslocoModule],
  styleUrls: ['intercom-messenger-bot.component.scss'],
  providers: [provideTranslocoScope('intercom')],
  templateUrl: './intercom-messenger-bot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntercomMessengerBotComponent {
  protected readonly scope = 'intercom.messengerBot';

  constructor(@Inject(DOCUMENT) document: Document, renderer: Renderer2) {
    renderer.addClass(document.body, 'app-loaded');
  }
}
